import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../_services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  form: any = {
    email: null,
  };

  errorMessage = '';

  constructor(private authService: AuthService, private http: HttpClient, private router: Router) { }

  ngOnInit(): void {
  }

  onSubmit(): void {
    const { email } = this.form;

    console.log("Email ", email)

    this.authService.reset(email).subscribe({
      next: data => {
        console.log("Data --> ", data)

        // this.tokenStorage.saveToken(data.uuid);
        // this.tokenStorage.saveUser(data);
        // this.isLoginFailed = false;
        // this.isLoggedIn = true;
        // // this.roles = this.tokenStorage.getUser().roles;
        // this.reloadPage();

        this.router.navigate(['/modifier-le-mot-de-passe']);

      },
      error: err => {
        this.errorMessage = err.error.message;
        console.log("Erreur")
      }
    });
  }

}
